<template>
  <div class="wrap">
    <div class="header" >
      <el-row >
        <el-col :span="14">
          <el-avatar
            icon="el-icon-user-solid"
            v-show="false"
            class="fl"
          ></el-avatar>
          <div class="fl ml10">
            <h4 class="userInfo">
              {{ user.studentName }}<br />
              <small>{{ user.studentCollege }}</small
              ><br />
              <small>{{ user.studentMajor }}</small>
            </h4>
          </div>
        </el-col>
        <el-col :span="10">
          <h4 class="prize" >
            我的奖品<br />
            <small
              >{{ myAward.updateTime | formatDate }}<br /><span
                v-if="myAward.updateTime && myAward.updateTime != ''"
                >抽到</span
              ><font style="color:rgb(191, 83, 88)">{{ myAward.award }}</font></small
            >
          </h4>
        </el-col>
      </el-row>
      <div class="block">
        <div class="horizontal-carousel">
          <h4 style="margin-top:5px; color:rgb(191, 83, 88);text-align:center">{{ campusName }}</h4>
        </div>        
        <div class="horizontal-carousel">
          <ol>
            <li v-for="itme in allAward">
              {{ itme.user.studentCollege }} {{ itme.user.studentName }}
              {{ itme.updateTime | formatDatess }}抽到了{{ itme.award }}
            </li>
          </ol>
        </div>
        <div class="box">
          <img src="http://sys.rennengda.com/weekon/cos/award/zhuanp@2x.png" width="100%" />
          <img src="http://sys.rennengda.com/weekon/cos/award/lottery_point.png" class="pointer" />
          <LuckyWheel
            class="luck-draw"
            ref="LuckyWheel"
            width="275px"
            height="275px"
            :prizes="prizes"
            :buttons="buttons"
            :default-style="defaultStyle"
            :default-config="defaultConfig"
            @start="startCallBack"
            @end="endCallBack"
          />
        </div>
      </div>
      <div class="block" style="margin:0 0.5rem 0.5rem 0.5rem;text-align:center;"> 
        <p v-if="jsonSetting.awardUrl" class="text-red">{{jsonSetting.awardPlace}}<a :href="jsonSetting.awardUrl">点击</a></p>
        <p v-else>{{jsonSetting.awardPlace}}</p>
      </div>
      <el-dialog
        :visible.sync="jiangpin"
        width="300px"
        class="text-center"
        :show-close="false"
      >
        <div style="margin-top: -20px">
          <span v-if="awarded.award != '谢谢参与'"
            >恭喜您获得了{{ awarded.idx }}：<font color="red">{{
              awarded.award
            }}</font>
            <img :src="awarded.imageUrl" width="80%" class="mt10"
          /></span>
          <span v-else>很遗憾未抽中奖品</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="jiangpin = false"
            style="width: 100%"
            >关 闭</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="cannotdraw"
        width="300px"
        class="text-center"
        :show-close="false"
      >
        <div style="margin-top: -20px">{{this.cannotdrawInfo}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="cannotdraw = false"
            style="width: 100%"
            >关 闭</el-button
          >
        </span>
      </el-dialog>
    </div>
    <div class="bottom">
        <button class="back-button" @click="emitBackActivities" >返回活动广场</button>
    </div>  
  </div>
</template>

<script>
import { mapState } from 'vuex'
import setWechatTitle from "@/utils/setWechatTitle.js";
import { formatTimeToStr } from "@/utils/date.js";
import qs from 'qs';
import axios from 'axios';
// import moment from 'moment';
export default {
  data() {
    return {
      prizes: [],
      awarded: {},
      buttons: [
        {
          radius: "40px",
          imgs: [
            {
              src: "http://sys.rennengda.com/weekon/cos/award/btn_lottery.png",
              width: "140%",
              top: "-135%",
            },
          ],
        },
      ],
      myAward: {},
      allAward: [],
      allAwardset: [],
      allAwardData: [],
      defaultStyle: {
        fontColor: "#000",
        fontSize: "13px",
        fontStyle: "SimHei",
      },
      jiangpin: false,
      cannotdraw: false,
      cannotdrawInfo: "",
      defaultConfig: {
        offsetDegree: 22.5,
      },
      maxDrawCount: 3,
      drawCount: 0,
      randomIndex: 0,
    };
  },
  computed: {   
    ...mapState({
      user: state => state.shengyaUser.userInfo,
    }),     
    jsonSetting() {
      return JSON.parse(this.user.admin.jsonSetting);
    },       
    notBegin() {
      return new Date().getTime()<this.user.operator.startTime;
    },   
    alreadyEnd() {
      return new Date().getTime()>this.user.operator.endTime;
    },  
    campusName() {
      return this.user.operator.campusName;
    }, 
    awardPlace() {
      let jsonSetting =JSON.parse(this.user.admin.jsonSetting);
      return jsonSetting.awardPlace;
    },  
    totalProbability() {
      console.log("computed totalProbability start...");
      let total = 0;
      this.allAwardset.forEach((item, index) => {
        if (item.award != "谢谢参与"){
          total = total + Number(item.winningRate);
        }
      });
      if(total>100){
        total = 100;
      }
      return total;
    },
    thanksProbability() {
      console.log("computed thanksProbability start...");
      let probability = 0;
      if(this.allAwardset.length<8){
        probability = (100 - this.totalProbability)*1.0/(8-this.allAwardset.length)
      }
      return probability;
    },
    weightSum() {
      console.log("computed weightSum start...");
      let sum = 0;
      this.allAwardData.map((item,index)=>{    //计算权重之和：1+5+20+74=100
        console.log("weightSum's item.award/winningrate/totalcount："+item.award+"/"+item.winningRate+"/"+item.totalCount);
        if (item.award != "谢谢参与") 
          sum += Number(item.winningRate);    
        else
          sum += this.thanksProbability;
      })  
      console.log("computed weightSum："+sum);
      return sum;
    },
    prizeWeight() {
      let sum = 0;
      let weight = [];
      this.allAwardData.map((item,index)=>{    //计算权重之和：1+5+20+74=100
        if (item.award != "谢谢参与") 
          sum += Number(item.winningRate);    
        else
          sum += this.thanksProbability;
        weight.push(sum)
      })
      return weight;
    },

  },
  filters: {
    formatDate: function (time) {
      //格式化时间
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy年MM月dd日  hh:mm");
      } else {
        return "";
      }
    },
    formatDatess: function (time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "hh:mm  ");
      } else {
        return "";
      }
    },
  },
  mounted() {
    console.log("mounted getAllAward start...");
    this.getAllAward();
  },
  created() {
    // console.log("new Date().getTime()/startTime/endTime："+new Date().getTime()+"/"+this.user.operator.startTime+"/"+this.user.operator.endTime);
    setWechatTitle("幸运大转盘");
    //获取当前用户中奖信息
    const options = {
      method: 'post',
      data: qs.stringify({openId: this.user.openid}),
      url:'/cob/cosMyAward.do'
    };
    axios(options)
    .then((res) => {
      res = res.data
      if (res.result.success) {         
        this.myAward = res.data;
      } else {
        this.myAward = { updateTime: "", award: "还未抽奖" };
      }
    })
    .catch(function (error) {
      console.warn(error);
    })
    //
    const options2 = {
      method: 'post',
      data: qs.stringify({openId: this.user.openid}),
      url:'/cob/getPageAwardByWhile.do'
    };
    axios(options2)      
    .then((res) => {
      res = res.data
      if (res.result.success) {   
        // let arr = this.selected.filter((item)=>{return item==2})
        this.allAward = res.data.results.filter((item)=>{return item.award!='谢谢参与'});
      } else {
        this.$store.commit('showMessage', {
          message: res.result.message,
          type: "error",
        })           
      }
    })
    .catch(function (error) {
      console.warn(error);
    })
  },

  methods: {
    getAllAward() {
      //获取所有奖品设置
      const options = {
        method: 'post',
        data: qs.stringify({openId: this.user.openid}),
        url:'/cob/getAllAwardSetting.do'
      };
      axios(options)      
      .then((res) => {
        res = res.data
        if (res.result.success) {   
          this.allAwardset = res.data;
          this.getPrizesList(res.data); //绘制转盘
        } else {
          this.$store.commit('showMessage', {
            message: res.result.message,
            type: "error",
          })              
        }
      })
      .catch(function (error) {
        console.warn(error);
      })
    },
    saveAward(prizes) {
      //保存抽奖信息
      const options = {
        method: 'post',
        data: qs.stringify({openId: this.user.openid, submitdata: prizes}),
        url:'/cob/saveCosAward.do'
      };
      axios(options)        
      .then((res) => {
        res = res.data
        if (res.result.success) {   
          this.myAward = res.data;
          this.user.arrCosAward[1] = "1";
          // let arrCosAward = this.user.arrCosAward;
          // arrCosAward[1] ="1";
          this.$bus.$emit('play-finish', this.user)   
        } else {
          this.$store.commit('showMessage', {
            message: res.result.message,
            type: "error",
          })              
        }
      })
      .catch(function (error) {
        console.warn(error);
      })
    },
    getPrizesList(data) {
      const prizes = [];
      const statusData = [];
      data.forEach((item, index) => {
        //获取未被禁用的奖品
        if (item.status == 1 && statusData.length < 8) { 
          if (item.totalCount<=0) { //数量为0，概率设为0
            item.winningRate='0';
          }
          statusData.push(item);
        }
      });
      data = statusData;
      if (data.length <= 4) {//小于等于4个奖项时
        //放上奖项+谢谢
        for (var i = 0; i < data.length; i++) {
          this.allAwardData.push(data[i]);
          this.allAwardData.push({ idx: "", award: "谢谢参与" });
        }
        //补上空缺-谢谢
        for (var j = 2 * data.length; j < 8; j++) {
          this.allAwardData.push({ idx: "", award: "谢谢参与" });
        }
      } else {//大于4个奖项时
        //放上奖项+谢谢
        for (var i = 0; i < 8 - data.length; i++) {
          this.allAwardData.push(data[i]);
          this.allAwardData.push({ idx: "", award: "谢谢参与" });
        }
        //补上剩余的奖项
        var startPrizeIndex = 8 - data.length;
        for (var j = 2 * (8 - data.length); j < 8; j++) {
          this.allAwardData.push(data[startPrizeIndex++]);
        }
      }
      //给转盘写入数据
      this.allAwardData.forEach((item, index) => {
        if (index % 2 === 0) {
          item.color = "#F8DEF8";
        } else {
          item.color = "#FEF3FC";
        }

        if (index < 8) {
          prizes.push({
            name: item.award,
            background: item.color,
            fonts: [
              {
                text: item.idx,
                top: "12%",
                fontColor: "#620",
                fontSize: "16px",
              },
              { text: item.award, top: "40%" },
            ],
          });
        }
      });
      this.prizes = prizes;
    },
    startCallBack() {
      if(this.notBegin){
        this.cannotdrawInfo =  "抽奖还未开始";
      }
      else if (this.alreadyEnd){
        this.cannotdrawInfo =  "抽奖已经结束";
      }
      else if(this.drawCount>=this.maxDrawCount){
        this.cannotdrawInfo =  "抽中的奖项没有库存了";
      }
      else{
        this.cannotdrawInfo =  "已抽过奖品，不能再抽";
      }
      console.log("cannotdrawInfo ："+this.cannotdrawInfo); 
      
      if(this.notBegin || this.alreadyEnd || this.drawCount>=this.maxDrawCount || this.myAward.award != "还未抽奖"){
        this.cannotdraw = true;
      }
      else if(this.allAwardData){
        this.drawAward();
      }      
    },
    endCallBack(prize) {
      this.allAwardData.forEach((item, index) => {
        if (item.award == `${prize.name}`) {
          this.awarded = item;
          //转盘停止后，显示获得奖品    
          this.myAward = item;
        }
      });
      this.jiangpin = true;
      // this.myAward = res.data;       
    },
    async drawAward(){
      //最多一次抽maxDrawCount次，防止无限循环“没有库存”bug
      this.drawCount =0;
      for(let i=0;i<this.maxDrawCount;i++){
        //
        this.myAward = {};
        const random = Math.random()*this.weightSum  //获取随机数
        const concatWeightArr = this.prizeWeight.concat(random)
        const sortedWeightArr = concatWeightArr.sort(function(a, b){return a-b;});    //将包含随机数的新权重数组按从小到大（升序）排序
        this.randomIndex = sortedWeightArr.indexOf(random);    //索引随机数在新权重数组中的位置
        console.info(this.allAwardData[this.randomIndex].award);
        //
        const saveAwardoption = {
          method: 'POST',
          data:qs.stringify({openId: this.user.openid, award: this.allAwardData[this.randomIndex].award, idx: this.allAwardData[this.randomIndex].idx}),
          url:"/cob/saveCosAward.do",
        }
        let res = await axios(saveAwardoption);
        res = res.data;
        // alert('res.result:'+typeof(res.result));
        if (res && res.result.success) {
          this.$refs.LuckyWheel.play();
          setTimeout(() => {
            this.$refs.LuckyWheel.stop(this.randomIndex);            
          }, 200);
          break;          
        }
        else{
          this.drawCount++;
        }            
      }
      //
      if(this.drawCount>=this.maxDrawCount){
        this.cannotdrawInfo =  "抽中的奖项没有库存了";
        this.cannotdraw = true;       
      }
    },    
    //返回广场
    emitBackActivities() {
      // this.$store.dispatch('quitMissionGroup',this.id)
      this.$bus.$emit('back-activities')
    }    
  },
};
</script>

<style scoped>
.fl {
  float: left;
}
.fr {
  float: right;
}
.mt20 {
  margin-top: 20px;
}
.mt10 {
  margin-top: 10px;
}
.ml10 {
  margin-left: 10px;
}
.wrap {
  padding: 10px;
}
.texR {
  text-align: right;
}
.text-center {
  text-align: center;
}
.show-box {
  background: #fff;
  margin: 10px;
  padding: 15px 10px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}
.text {
  width: 50%;
  position: relative;
}
.text h4 {
  position: absolute;
  top: 50px;
  margin-top: -30px;
  width: 100%;
  text-align: center;
}
.userInfo,
.prize,
.text h4 {
  font-weight: normal;
  color: #333;
  font-size: 14px;
}
.userInfo small,
.prize small,
.text h4 small {
  font-size: 12px;
}
.prize {
  text-align: right;
}
.horizontal-carousel {
  /* 一定要隐藏掉超出部分的内容 */
  overflow: hidden;
  width: 100%;
  height: 30px;
}
.horizontal-carousel ol {
  /* 这里不能设为inline，否则translate不起作用要用margin-left来做动画 */
  display: inline-block;
  /* 强制不换行，不设的话由于内容较多会换行到下方 */
  white-space: nowrap;
  animation: horizontal-move 80s linear infinite;
  /* 容器的宽度，似乎纯CSS的话只能写死 */
  transform: translate(500px);
  margin: 0;
}
@keyframes horizontal-move {
  0% {
    transform: translate(500px);
  }
  100% {
    /* 100%是自身的宽度 */
    transform: translate(calc(-500px - 100%));
  }
}
.horizontal-carousel ol li {
  display: inline-block;
  margin: 0 10px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 20px;
  border-radius: 5px;
  color: #fff;
  padding: 0 10px;
  font-size: 12px;
}
.box {
  position: relative;
  width: 350px;
  height: 350px;
  margin: 20px auto;
}
.pointer {
  width: 68px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  z-index: 999;
  top: -18px;
}
.luck-draw {
  width: 275px;
  height: 275px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.bottom {
  padding: 0.24rem;
}
.bottom .back-button {
  width: 100%;
  height: 0.84rem;
  background: #787878;
  border-radius: 0.12rem;
  color: #fff;
}
.bottom  .disabled-btn {
  background :#BBBBBB
}

</style>
